import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { RestEndpoint } from '../../../constants/rest-endpoint.constants';

export interface ICountryAlert {
    country: string;
    title: string;
    alert: string;
}

@Injectable({ providedIn: 'root' })
export class CountryAlertsService {

    constructor(private readonly http: HttpClient) { }

    public getCountryAlerts(): Observable<Array<ICountryAlert>> {
        return this.http.get<Array<ICountryAlert>>(RestEndpoint.countryAlerts).pipe(
            catchError(() => of([]))
        );
    }
}
